import { Fragment, Node, Slice } from '@tiptap/pm/model'

export const mapFragment = (
  fragment: Fragment,
  callback: (node: Node) => Node | Node[] | Fragment | null
): Fragment => {
  return fragment
    ? Fragment.fromArray(
        (fragment as any).content
          .map((node: Node) => {
            if (node?.content?.childCount > 0) {
              return node.type.create(
                node.attrs,
                mapFragment(node.content, callback)
              )
            }

            return callback(node)
          })
          .filter(Boolean)
      )
    : Fragment.empty
}
export const mapSlice = (
  slice: Slice,
  callback: (node: Node) => Node | Node[] | Fragment | null
): Slice => {
  const fragment = mapFragment(slice.content, callback)
  return new Slice(fragment, slice.openStart, slice.openEnd)
}
